export default __webpack_public_path__ + "static/media/general_math.2dc84890.png";